import * as fromDatatype from "../datatype-library/index";

export interface bl_alg_cc_qc_monthly_line_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	hdr_guid : fromDatatype.GuidDataFieldInterface;
    task_guid : fromDatatype.GuidDataFieldInterface;
    completed_status : boolean;
	name: fromDatatype.TextDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	type: fromDatatype.VarcharDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_alg_cc_qc_monthly_line_RowClass
	implements bl_alg_cc_qc_monthly_line_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	hdr_guid : fromDatatype.GuidDataFieldInterface;
    task_guid : fromDatatype.GuidDataFieldInterface;
    completed_status : boolean;
	name: fromDatatype.TextDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	type: fromDatatype.VarcharDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
